module.exports = __webpack_public_path__ + "media/application/images/ui/purchase/best-value-label-cba525f95bc427ee6b3a9e2a39815db0.png";